import { render, staticRenderFns } from "./childrenages.vue?vue&type=template&id=8df3bd46&"
import script from "./childrenages.vue?vue&type=script&lang=js&"
export * from "./childrenages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df3bd46')) {
      api.createRecord('8df3bd46', component.options)
    } else {
      api.reload('8df3bd46', component.options)
    }
    module.hot.accept("./childrenages.vue?vue&type=template&id=8df3bd46&", function () {
      api.rerender('8df3bd46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h8Dha5MgiPrv/JS/childrenages.vue"
export default component.exports